import Vue from 'vue';

export default function install (Vue: Vue.VueConstructor) {
  Vue.prototype.$rules = {
    required: (value: string) => !!value || 'Påkrevd.',
    phoneNumber: (value: string) => {
      const pattern = /^[\d|\s]{8}$/
      return pattern.test(value) || 'Ugyldig telefonnummer.'
    },
    email: (value: string) => {
      const pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/
      return pattern.test(value) || 'Ugyldig epostadresse.'
    },
    code: (value: string) => {
      const pattern = /^[\d]+$/
      return pattern.test(value) || 'Ugyldig kode.'
    },
  }
}